import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import type { NavItem } from '../nav';

interface Props {
  items: NavItem[];
  title: string;
  onLogout: () => void;
}

export default function Sidebar({ items, title, onLogout }: Props) {
  const location = useLocation();
  const initiallyExpanded = items.some((i) => i.children?.some((c) => c.to === location.pathname));
  const [expanded, setExpanded] = useState(initiallyExpanded);

  return (
    <aside className="flex h-screen w-60 flex-col overflow-hidden bg-gray-900 text-white">
      <div className="border-b border-gray-700 px-6 py-5 text-xl font-bold">{title}</div>

      <nav className="flex-1 overflow-y-auto py-4">
        {items.map((item) => {
          if (item.children && item.children.length > 0) {
            return (
              <div key={item.testId} data-testid={item.testId}>
                <button
                  onClick={() => setExpanded((v) => !v)}
                  className={`flex w-full items-center justify-between px-6 py-3 text-sm transition-colors ${
                    expanded
                      ? 'bg-gray-800 text-white'
                      : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                  }`}
                >
                  <span>{item.label}</span>
                  <span className={`text-xs transition-transform ${expanded ? 'rotate-90' : ''}`}>
                    ▸
                  </span>
                </button>
                {expanded && (
                  <div className="bg-gray-800/50">
                    {item.children.map((child) => (
                      <NavLink
                        key={child.testId}
                        to={child.to}
                        data-testid={child.testId}
                        className={({ isActive }) =>
                          `flex items-center gap-3 py-2.5 pl-12 pr-6 text-sm transition-colors ${
                            isActive
                              ? 'bg-white text-black'
                              : 'text-gray-400 hover:bg-gray-700 hover:text-white'
                          }`
                        }
                      >
                        {child.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          }

          return (
            <NavLink
              key={item.testId}
              to={item.to}
              end={item.to === '/'}
              data-testid={item.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-3 text-sm transition-colors ${
                  isActive ? 'bg-white text-black' : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`
              }
            >
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="border-t border-gray-700 px-6 py-4">
        <button onClick={onLogout} className="w-full text-left text-sm text-gray-400 hover:text-white">
          退出登录
        </button>
      </div>
    </aside>
  );
}
